$ = require 'jquery'
ActionListView = require 'app/scripts/views/action/action-list-view'
AddChecklistMenu = require 'app/scripts/views/checklist/add-checklist-menu'
Alerts = require 'app/scripts/views/lib/alerts'
{ Analytics } = require '@trello/atlassian-analytics'
AttachmentHelpers = require 'app/scripts/views/attachment/helpers'
AttachmentThumbView = require 'app/scripts/views/attachment/attachment-thumb-view'
AttachmentTypePickerView = require 'app/scripts/views/card/attachment-type-picker-view'
AttachmentViewer = require 'app/scripts/views/internal/attachment-viewer'
Auth = require 'app/scripts/db/auth'
AutoInsertionView = require 'app/scripts/views/internal/autocomplete/auto-insertion-view'
AutoMentionerView = require 'app/scripts/views/internal/autocomplete/auto-mentioner-view'
Browser = require '@trello/browser'
TrelloCompleterView = require 'app/scripts/views/internal/autocomplete/trello-completer-view'
CardAgingPopoverView = require 'app/scripts/views/card-aging/card-aging-popover-view.coffee'
CardCopyView = require 'app/scripts/views/card/card-copy-view'
{ toggleCardCoverChooserPopover } = require 'app/scripts/views/card/card-cover-chooser-popover.tsx'
CardDetailMoreMenuView = require 'app/scripts/views/card/card-detail-more-menu-view'
{ showDetails, hideDetails, showAllActions, renderShowAllActionsButton, renderActionList, renderSuggestedActions } = require 'app/scripts/views/card/card-detail-view-actions'
CardLabelSelectView = require 'app/scripts/views/label/card-label-select-view'
{ maybeDisplayLimitsErrorOnCardOpen } = require 'app/scripts/views/card/card-limits-error'
CardLocationView = require 'app/scripts/views/map/card-location-view'
CardMemberSelectView = require 'app/scripts/views/card/card-member-select-view'
CardMoveView = require 'app/scripts/views/card/card-move-view'
CardViewHelpers = require 'app/scripts/views/card/card-view-helpers'
ChecklistView = require 'app/scripts/views/checklist/checklist-view'
CompleterUtil = require 'app/scripts/views/internal/autocomplete/completer-util'
Confirm = require 'app/scripts/views/lib/confirm'
Controller = require 'app/scripts/controller'
CustomFieldCardDetailBadgesView = require 'app/scripts/views/custom-field/custom-field-card-detail-badges-view'
CustomFieldsButtonView = require 'app/scripts/views/custom-field/custom-fields-button-view'
DatePickerView = require 'app/scripts/views/card/date-picker-view'
Dates = require 'app/scripts/lib/dates'
DescriptionView = require 'app/scripts/views/description/description-view'
Dialog = require 'app/scripts/views/lib/dialog'
require 'app/scripts/views/internal/data-transfer/drag-drop-events'
DragSort = require 'app/scripts/views/lib/drag-sort'
DueDateHelpers = require 'app/scripts/views/internal/due-date-helpers'
EditableView = require 'app/scripts/views/internal/editable-view'
{ firstPartyPluginsOrg } = require '@trello/config'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ Feedback } = require 'app/src/components/Feedback'
FormattingHelpView = require 'app/scripts/views/card/formatting-help-view'
Hearsay = require 'hearsay'
InProgressAttachmentView = require 'app/scripts/views/attachment/in-progress-attachment'
{ getKey, isForceSubmitEvent, Key, registerShortcutHandler, Scope, unregisterShortcutHandler, } = require '@trello/keybindings'
Label = require 'app/scripts/models/label'
LabelKeyHelper = require 'app/scripts/views/label/label-key-helper'
Layout = require 'app/scripts/views/lib/layout'
LegacyPowerUps = require 'app/scripts/data/legacy-power-ups'
LimitExceeded = require 'app/scripts/views/attachment/attachment-limit-exceeded-error'
MemberState = require 'app/scripts/view-models/member-state'
MembersVotedView = require 'app/scripts/views/member/members-voted-view'
ModelCache = require 'app/scripts/db/model-cache'
ModelLoader = require 'app/scripts/db/model-loader'
Monitor = require 'app/scripts/lib/monitor'
PasteInput = require 'app/scripts/views/internal/paste-input'
PluginCardButtonsView = require 'app/scripts/views/plugin/plugin-card-buttons-view'
PluginCardDetailBadgesView = require 'app/scripts/views/plugin/plugin-card-detail-badges-view'
PluginIOCache = require 'app/scripts/views/internal/plugins/plugin-io-cache'
PluginModelSerializer = require 'app/scripts/views/internal/plugins/plugin-model-serializer'
PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
PluginSectionView = require 'app/scripts/views/plugin/plugin-section-view'
PluginCardBackSectionView = require 'app/scripts/views/plugin/plugin-card-back-section-view'
PopOver = require 'app/scripts/views/lib/pop-over'
PluginSuggestionPopOver = require 'app/scripts/views/plugin/plugin-suggestion-pop-over'
Promise = require 'bluebird'
SetCardLocationPopoverView = require 'app/scripts/views/map/set-card-location-popover-view'
StickerView = require 'app/scripts/views/stickers/sticker-view'
{ Storage } = require '@trello/storage'
TFM = require 'app/scripts/lib/markdown/tfm'
Tooltip = require 'app/scripts/views/lib/tooltip'
TrelloBoardAttachment = require 'app/scripts/views/attachment/trello-board-attachment'
TrelloCardAttachment = require 'app/scripts/views/attachment/trello-card-attachment'
{ UnsplashTracker } = require '@trello/unsplash'
Util = require 'app/scripts/lib/util'
UploadingLinkView = require 'app/scripts/views/card/uploading-link-view'
WindowSize = require 'app/scripts/lib/window-size'
_ = require 'underscore'
f = require 'effing'
friendlyLinks = require 'app/scripts/views/internal/friendly-links'
{ getSuggestionsFeedback } = require 'app/scripts/views/feedback/collectors/get-suggestions-feedback'
log = require 'app/scripts/debug/log'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
moment = require 'moment'
l = require 'app/scripts/lib/localize'
localizeCount = require 'app/scripts/lib/localize-count'
pastedFileName = require 'app/scripts/views/internal/pasted-file-name'
warnIfFileTooLarge = require 'app/scripts/views/internal/warn-if-file-too-large'
ninvoke = require 'app/scripts/lib/util/ninvoke'
cardDetailTemplate = require 'app/scripts/views/templates/card_detail'
cardDetailListTemplate = require 'app/scripts/views/templates/card_detail_list'
cardDetailAddButtonTemplate = require 'app/scripts/views/templates/card_detail_add_button'
cardDetailToggleButtonTemplate = require 'app/scripts/views/templates/card_detail_toggle_button'
labelTemplate = require 'app/scripts/views/templates/label'
editInProgressTemplate = require 'app/scripts/views/templates/edit_in_progress'
removeAllRanges = require 'app/scripts/lib/util/removeAllRanges'
parseTrelloUrl = require 'app/scripts/lib/util/url/parse-trello-url'
pluginsChangedSignal = require 'app/scripts/views/internal/plugins/plugins-changed-signal'
pluginCoverWithDefaults = require 'app/scripts/lib/plugins/plugin-cover-with-defaults'
pluginValidators = require 'app/scripts/lib/plugins/plugin-validators'
TrelloClipboard = require 'app/scripts/lib/trello-clipboard'
{ toggleSuggestionsSettings } = require 'app/scripts/views/suggestions-settings/toggle-suggestions-settings'
{ Noun, Verb, track, trackUe, trackDebounced } = require '@trello/analytics'
{ animateRender, animateRemove } = require './animate-card'
{ getPotentialCovers } = require 'app/src/components/CardCoverChooser/SelectCover'
CARD_AGING_POWER_UP_ID = require('app/scripts/data/legacy-power-ups').cardAging
CUSTOM_FIELDS_ID = require('@trello/config').customFieldsId
MAP_POWER_UP_ID = require('@trello/config').mapPowerUpId
{ renderComponent } = require 'app/src/components/ComponentWrapper'
{ PowerUpSuggestionContainer, getClaimedSecondLevelDomainsToPluginMapForOrg, doesMatchClaimedDomain, getSecondLevelDomain } = require 'app/src/components/PowerUpAttachmentSectionSuggestion'
{ sendPluginScreenEvent, sendPluginUIEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'
React = require 'react'
{ CardBackBanner } = require 'app/src/components/CardBackBanner'
ReactDOM = require '@trello/react-dom-wrapper'
{ trackSeparator } = require 'app/scripts/views/card/SeparatorCard/SeparatorCard'
{ shouldFireConfetti } = require 'app/scripts/views/card/should-fire-confetti'
confetti = require('canvas-confetti').default

{ saveCardName, nameKeyDownEvent, startNameEditing, saveNameEditing, cancelNameEditing, stopNameEditing, renderName, editTitle } = require './card-detail-view-name'
{ convertToTemplate, convertToCard, renderCardTemplate, isOnBoardTemplate } = require './card-detail-view-template'
{ openCoverInViewer, removeCover, showCover, checkShowCover, clearCover, renderCover, cardCoverChooserSidebar } = require './card-detail-view-cover'
{ renderSubscribe, subscribeToCard, unsubscribeFromCard } = require './card-detail-view-subscribe'
{ showVotes, renderVotes, vote, unvote } = require './card-detail-view-vote'
{ archiveCard, unarchiveCard, renderArchived, renderDelete, deleteCardSidebar } = require './card-detail-view-archive'
{ openMoveMenu, openMoveFromHeader, moveCard, copyCard, renderCopyCard } = require './card-detail-view-copy-move'
{ openLabelsPopOver, editLabelsMainSingleLabel, editLabelsMain, editLabelsSidebar, renderLabels, _openEditLabelsSidebar } = require './card-detail-view-label'
{ renderAddChecklists, renderDueDate, sortChecklists, removeChecklist, renderChecklists, sortStop, onChecklistClick, onChecklistShortcut, addChecklistSidebar, showDueDateBadgeMenu, toggleDueDateComplete, dueDateSidebar, focusChecklistAdd } = require './card-detail-view-checklist'
{ renderEditing, openEditMembersPopOver, editMembersMain, changeMembersSidebar, join, renderMembers } = require './card-detail-view-members'
{ incrementNumAttachmentsProcessing, decrementNumAttachmentsProcessing, incrementNumTrelloAttachmentsProcessing, decrementNumTrelloAttachmentsProcessing, attachComment, openAttachPicker, openAttachTrelloPicker, renderAddAttachments, showFewerAttachments, showMoreAttachments, showFewerTrelloAttachments, showMoreTrelloAttachments, renderAttachments, dragenter, dragleave, dropFiles, dropUrl, enableAttachmentSorting, getTrelloAttachments, sortStopAttachments } = require './card-detail-view-attachment'
{ _commentDraftKey, saveCommentDraft, keydownCommentEvent, _isCommentTooLong, renderCommentSubmitAbility, renderCommentControls, renderCommentAndSubscribeBox, _cancelEditing, commentInputEvent, clearComment, submitComment, subscribeOnComment, truncateComment, inputComment, clickAwayFromComment, collapseComment, replyToAction, replyToAllAction, replyToAttachment, replyToComment } = require './card-detail-view-comment'
{ highlight, interceptHighlightLink, scrollToHighlight } = require './card-detail-view-highlight'
{ renderPluginButtons, renderCustomFieldBadges, renderPluginBadges, renderStickers, renderAging, dismissPluginSuggestionSection, enableSuggestedPluginPrompt, renderPluginSections, editFieldsSidebar, editLocationSidebar, renderLocation, cardAgingSidebar, dismissDropdownSection } = require './card-detail-view-plugins'
{ markNotificationsReadOnActive, markRelatedNotificationsRead } = require './card-detail-view-notifications'

module.exports = mixin AutoInsertionView, CompleterUtil, CardViewHelpers, class CardDetailView extends EditableView
  className: 'card-detail-window u-clearfix'
  defaultActionLimit: 50
  maxActionLimit: 1000
  maximumCommentLength: 16384 # This is the most the API accepts for a string
  maxDescLength: 1800 # When to truncate the desc and show "Show full description."

  addListListener: ->
    # Archived lists may be loaded later so listening to @model.getList() won't
    # work until the data is loaded.

    # Clean up any old event listeners.

    idOldList = @model.previous('idList')

    if idOldList
      @stopListening(@modelCache, "add:List:#{ idOldList }")

      oldList = @modelCache.get('List', idOldList)
      @stopListening(oldList, 'change:closed')

    # Render list, add new listeners.

    handleList = =>
      @renderListDebounced()
      @renderArchivedDebounced()
      @renderDeleteDebounced()
      @listenTo @model.getList(),
        'change:closed': =>
          @renderArchivedDebounced()
          @renderDeleteDebounced()

    if @model.getList()
      handleList()
    else
      @listenToOnce @modelCache, "add:List:#{ @model.get('idList') }", handleList

    return

  initialize: ->
    super

    @makeDebouncedMethods 'render',
      'renderAddAttachments'
      'renderAddChecklists'
      'renderCover'
      'renderStickers'
      'renderName'
      'renderArchived'
      'renderDelete'
      'renderLabels'
      'renderList'
      'renderVotes'
      'renderDueDate'
      'renderSubscribe'
      'renderAttachments'
      'renderMembers'
      'renderAging'
      'renderCustomFieldBadges'
      'renderPluginSections'
      'renderLocation'
      'renderCardTemplate'

    @listenTo @model,
      'change:name': @renderNameDebounced
      'change:closed': =>
        @renderArchivedDebounced()
        @renderDeleteDebounced()
      'change:isTemplate': =>
        @renderArchivedDebounced()
        @renderDeleteDebounced()
        @renderCardTemplateDebounced()
        @renderDueDateDebounced()
        @renderVotesDebounced()
      'change:labels': @renderLabelsDebounced
      'change:limits': =>
        @renderAddAttachmentsDebounced()
        @renderAddChecklistsDebounced()
      'change:idList': =>
        @renderListDebounced()
        @addListListener()
      'change:idMembersVoted': @renderVotesDebounced
      'change:due change:dueComplete': @renderDueDateDebounced
      'change:subscribed': @renderSubscribeDebounced
      'change:dateLastActivity': =>
        @renderAgingDebounced()
        @renderCoverDebounced()
        @renderPluginSectionsDebounced()
      'change:idAttachmentCover change:cover': ->
        @renderCoverDebounced()
      'destroy': @closeDialog
      'change:badges.votes': ->
        ModelLoader.loadCardVoters(@model.id).done()
      'change:coordinates': @renderLocationDebounced
      'change:idBoard': @closeDialog

    @addListListener()

    @listenTo @model.customFieldItemList, 'add remove reset change', =>
      @renderCustomFieldBadgesDebounced()

    @listenTo @model.labelList, 'add remove reset change', =>
      @renderLabelsDebounced()

    @listenTo @model.memberList,
      'add remove reset': @renderMembersDebounced

    @listenTo @model.memberList, 'change:initials change:avatarUrl change:avatarSource change:fullName change:username': @renderMembersDebounced

    @listenTo @model.memberVotedList,
      'add remove reset': @renderVotesDebounced

    @listenTo @model.checklistList,
      'add reset': @renderChecklists
      'remove': @removeChecklist
      'sort': @sortChecklists

    @listenTo @model.attachmentList,
      'add remove reset sort': @renderAttachmentsDebounced

    @listenTo @model.stickerList,
      'add remove reset change sort': @renderStickersDebounced

    @listenTo @model.memberEditingList,
      'add remove reset change:action': @renderEditing

    board = @model.getBoard()
    @listenTo board,
      'change:labelNames': @renderLabelsDebounced
      'change:labels': @renderLabelsDebounced
      'change:limits': @renderAddChecklistsDebounced
      'change:prefs': (board) ->
        changed = (pref) ->
          board.get('prefs')?[pref] != board.previous('prefs')?[pref]
        # Try to be as specific as possible about what we rerender
        if changed('cardCovers')
          @renderCover()

        # Re-rendering the whole card will mess up in-progress edits, so don't
        # ever do that if there is an edit in progress
        requiresFullRender =
          changed('cardAging') || changed('comments') || changed('voting') || changed('isTemplate')
        if requiresFullRender && @$('.editing').length == 0
          @renderDebounced()

        if changed('hideVotes')
          @renderVotesDebounced()

    @listenTo board.customFieldList, 'add remove reset change', =>
      @renderCustomFieldBadgesDebounced()

    @listenTo board.boardPluginList, 'add remove reset change', =>
      @renderCustomFieldBadgesDebounced()
      @renderAgingDebounced()
      @renderLocationDebounced()

    # Some members might be in the card but not have made it to the board yet.
    # In that case, they won't be rendered, as being in a card but not its
    # board is considered an invalid state. When that is resolved - when the
    # member finally makes it to the board - rerender all members to get the
    # complete list.
    @listenTo board.memberList,
      'add remove reset': @renderMembersDebounced

    @listenTo MemberState, 'change:showSuggestions', =>
      @renderSuggestedActions()

    # subscribing to these continuous signals will fire once immediately
    # in this case we don't want that as it will be a duplicate call
    @subscribe pluginsChangedSignal(board, @model), _.after 2, =>
      @renderCoverDebounced()
      @renderAttachmentsDebounced()
      @renderPluginSectionsDebounced()
      @renderLocationDebounced()
      @renderAgingDebounced()

    @getData()

    @numAttachmentsProcessing = @slot(0)
    @watch 'numAttachmentsProcessing', _.after 2, =>
      @renderAttachmentsDebounced()

    @numTrelloAttachmentsProcessing = @slot(0)
    @watch 'numTrelloAttachmentsProcessing', _.after 2, =>
      @renderAttachmentsDebounced()

    # It's possible, if a card was just created, that it won't have the
    # desc specified yet
    @fHideFullDescription = @model.get('desc')?.length > @maxDescLength

    @actionListView = @collectionSubview ActionListView, @model.actionList,
      renderOpts:
        context: @model
        compact: false

    @markNotificationsReadOnActive()
    @listenTo Monitor, 'setStatus visibilitychange', @markNotificationsReadOnActive
    @listenTo ModelCache, 'add:Notification', (notification) =>
      if notification? && notification.get('data')?.card?.id == @model.id
        @markNotificationsReadOnActive()

    $(window).on "beforeunload.CardDetailView-#{@model.cid}", f(@, 'saveCommentDraft', true)

    @pluginThumbTrackCache = {}

    # Pre-set the clipboard to contain the card URL so if the user copies, the cards URL will
    # make it to their clipboard even if the user is directly navigating to a card route.
    TrelloClipboard.set(@model.getFullUrl())

    @listenTo Auth.me().boardList, 'add remove reset change:closed', @renderCopyCard

    @descView = @subview DescriptionView, @model,
      maxDescLength: @maxDescLength
      card: @model
      board: @model.getBoard()
      placeholderKey: 'add-a-more-detailed-description'
      source: 'cardDetailScreen' # for GAS analytics

    registerShortcutHandler(@onShortcut, { scope: Scope.Dialog })
    PasteInput.addHandler(@, { scope: 'dialog' })

    @colorCoversFlagEnabled =
      featureFlagClient.get('remarkable.color-covers', false)

    if featureFlagClient.get('dataeng.gasv3-core-event-tracking', false)
      Analytics.sendScreenEvent
        name: 'cardDetailScreen'
        containers:
          card:
            id: @model?.id || ''
          list:
            id: @model?.getList()?.id || ''
          board:
            id: @model?.getBoard()?.id || ''
          organization:
            id: @model?.getBoard()?.getOrganization()?.id || ''

    ################################
    # START - Card back transition #
    ################################

    if (featureFlagClient.get('animations', false))
      animateRender(this)

    ################################
    # END - Card back transition   #
    ################################


  remove: ->
    @saveCommentDraft(true)
    $(window).off ".CardDetailView-#{@model.cid}"
    unregisterShortcutHandler(@onShortcut)
    PasteInput.removeHandler(@)

    ################################
    # START - Card back transition #
    ################################
    if (featureFlagClient.get('animations', false))
      animateRemove(this)
    ################################
    # END - Card back transition   #
    ################################

    @removeBanner()

    super
    return

  events:
    # sidebar
    'click .js-edit-labels': 'editLabelsSidebar'
    'click .js-change-card-members': 'changeMembersSidebar'
    'click .js-add-checklist-menu': 'onChecklistClick'
    'click .js-add-due-date': 'dueDateSidebar'
    'click .js-card-cover-chooser': 'cardCoverChooserSidebar'
    'click .js-attach': 'openAttachPicker'
    'click .js-attach-trello-attachment': 'openAttachTrelloPicker'
    'click .js-join': 'join'
    'click .js-suggested-actions-settings': toggleSuggestionsSettings('Card Detail')
    'click .js-suggested-actions-feedback': getSuggestionsFeedback({ placement: 'Card Detail' })

    'click .js-edit-fields': 'editFieldsSidebar'
    'click .js-edit-location': 'editLocationSidebar'
    'click .js-card-aging-card-button': 'cardAgingSidebar'

    'click .js-move-card': 'moveCard'
    'click .js-copy-card': 'copyCard'
    'click .js-subscribe': 'subscribeToCard'
    'click .js-unsubscribe': 'unsubscribeFromCard'
    'click .js-vote': 'vote'
    'click .js-unvote': 'unvote'
    'click .js-convert-to-template': 'convertToTemplate'
    'click .js-convert-to-card': 'convertToCard'

    'click .js-archive-card': 'archiveCard'
    'click .js-unarchive-card': 'unarchiveCard'
    'click .js-delete-card': 'deleteCardSidebar'

    'click .js-more-menu': 'showMoreMenu'

    # title
    'keydown  .js-card-detail-title-input': 'nameKeyDownEvent'
    'focus    .js-card-detail-title-input': (e) ->
      @startNameEditing({ focus: false })

    'blur     .js-card-detail-title-input': 'saveNameEditing'

    # main col
    'click .js-remove-cover': 'removeCover'
    'click .js-open-card-cover-in-viewer': 'openCoverInViewer'
    'click .js-open-move-from-header': 'openMoveFromHeader'
    'click .js-details-edit-members': 'editMembersMain'
    'click .js-details-edit-labels': 'editLabelsMain'
    'click .js-edit-label .card-label': 'editLabelsMainSingleLabel'
    'click .js-details-edit-due-date': 'showDueDateBadgeMenu'
    'click .js-details-toggle-due-date-complete': 'toggleDueDateComplete'
    'click .js-show-votes': 'showVotes'
    'click .js-member-on-card-menu': 'openMemberOnCardMenu'

    'click .js-view-some-attachments': 'showFewerAttachments'
    'click .js-view-all-attachments': 'showMoreAttachments'
    'click .js-view-some-trello-attachments': 'showFewerTrelloAttachments'
    'click .js-view-all-trello-attachments': 'showMoreTrelloAttachments'
    'click .js-show-all-actions': 'showAllActions'

    # comments
    'keydown .js-new-comment-input': 'keydownCommentEvent'
    'input .js-new-comment-input': 'commentInputEvent'
    'mutated .js-new-comment-input': 'commentInputEvent'
    'click .js-add-comment:not(:disabled)': 'submitComment'
    'click .js-comment-subscribe': 'subscribeOnComment'
    'click .js-attach-comment': 'attachComment'
    'click .js-truncate-comment': 'truncateComment'
    'click .js-new-comment': 'inputComment'
    'focus .js-new-comment-input': 'inputComment'
    'keyup .js-new-comment-input': 'keyAutoMention'
    'click': 'clickAwayFromComment'

    'click .js-new-comment .js-comment-add-attachment': 'commentAddAttachment'
    'click .js-new-comment .js-comment-mention-member': 'commentMentionMember'
    'click .js-new-comment .js-comment-add-emoji': 'commentAddEmoji'
    'click .js-new-comment .js-comment-add-card': 'commentAddCard'

    'click .js-show-details': 'showDetails'
    'click .js-hide-details': 'hideDetails'

    'click a[href]': 'interceptHighlightLink'

    # attachments
    'dd-enter:files': 'dragenter'
    'dd-leave:files': 'dragleave'
    'dd-drop:files': 'dropFiles'
    'dd-enter:url': 'dragenter'
    'dd-leave:url': 'dragleave'
    'dd-drop:url': 'dropUrl'
    'pasteinput:files': 'dropFiles'
    'pasteinput:url': 'dropUrl'

    # checklist sort
    'sortstop .js-checklist-list': 'sortStop'

    'sortstop .js-attachment-list': 'sortStopAttachments'

    'replyToAction': 'replyToAction'
    'replyToAllAction': 'replyToAllAction'

    # Watch via comment tooltip
    'mouseenter .js-comment-subscribe': (e) ->
      $el = @$(e.currentTarget)
      Tooltip.show($el.attr('aria-label'), $el, false, Tooltip.STYLE.MENU)

    'mouseleave .js-comment-subscribe': (e) ->
      Tooltip.hide()

  onShortcut: (event) =>
    board = @model.getBoard()
    editable = @model.editable()
    isTemplate = !!@model.get('isTemplate')
    loggedIn = Auth.isLoggedIn()
    isOnBoardTemplate = @isOnBoardTemplate()
    key = getKey(event)

    switch key
      when Key.Space
        if editable && !isOnBoardTemplate && (board.hasActiveMembership(Auth.me()) || board.isEditableByTeamMemberAndIsNotABoardMember())
          # TODO: requestJoinBoard unecessary once WLRS-495 ships
          toggleMemberFn = => @model.toggleMember(Auth.myId())
          board.requestJoinBoard(toggleMemberFn)
          event.preventDefault()
          track 'Keyboard Shortcuts', 'Space - Toggle Assigning Self', 'Card Detail'

      when Key.a, Key.m
        if editable && !isOnBoardTemplate
          @changeMembersSidebar()
          event.preventDefault()
          track 'Keyboard Shortcuts', 'A - Assign Members', 'Card Detail'

      when Key.e
        if editable
          @descView.editDesc()
          event.preventDefault()
          track 'Keyboard Shortcuts', 'E - Edit Description', 'Card Detail'

      when Key.l
        if editable
          @_openEditLabelsSidebar({ hideOnSelect: false })
          event.preventDefault()
          track 'Keyboard Shortcuts', 'L - Edit Labels', 'Card Detail'

      when Key.d
        if editable && !isTemplate
          if @model.get('due')?
            @showDueDateBadgeMenu()
          else
            @dueDateSidebar()
          event.preventDefault()
          track 'Keyboard Shortcuts', 'D - Due Dates', 'Card Detail'

      when Key.Dash
        if editable
          @onChecklistShortcut()
          event.preventDefault()
          track 'Keyboard Shortcuts', '- - Add Checklist'

      when Key.c
        if editable
          @archiveCard()
          event.preventDefault()
          track 'Keyboard Shortcuts', 'C - Archive Card'

      when Key.t
        if editable
          @editTitle()
          event.preventDefault()
          track 'Keyboard Shortcuts', 'T - Edit Title'

      when Key.AngleRight, Key.Period
        if editable
          @model.moveToNextList(if key == Key.AngleRight then 'top' else 'bottom')
          event.preventDefault()
          track 'Keyboard Shortcuts', '> - Move to Next List'

      when Key.AngleLeft, Key.Comma
        if editable
          @model.moveToPrevList(if key == Key.AngleLeft then 'top' else 'bottom')
          event.preventDefault()
          track 'Keyboard Shortcuts', '< - Move to Previous List'

      when Key.Zero, Key.One, Key.Two, Key.Three, Key.Four, \
           Key.Five, Key.Six, Key.Seven, Key.Eight, Key.Nine
        if editable
          fxNoUniqueLabel = (color) =>
            @_openEditLabelsSidebar({ searchInit: color, hideOnSelect: true })
          LabelKeyHelper.setLabelFromKey(key, @model, fxNoUniqueLabel)
          event.preventDefault()
          track 'Keyboard Shortcuts', '0-9 - Toggle Specific Label'

      when Key.v
        if !isTemplate && board.canVote(Auth.me())
          @model.toggleVote()
          event.preventDefault()
          track 'Keyboard Shortcuts', 'V - Vote'

      when Key.s
        if loggedIn && !isOnBoardTemplate
          subscribed = @model.get('subscribed')
          @model.subscribe(!subscribed)
          event.preventDefault()
          track 'Keyboard Shortcuts', 'S - Subscribe', if subscribed then "Unsubscribe" else "Subscribe"

      when Key.j
        if (nextCard = @model.nextCard())?
          Controller.showCardDetail(nextCard, { isNavigating: true })
          event.preventDefault()
          track 'Keyboard Shortcuts', 'J - Down'

      when Key.k
        if (prevCard = @model.prevCard())?
          Controller.showCardDetail(prevCard, { isNavigating: true })
          event.preventDefault()
          track 'Keyboard Shortcuts', 'K - Up'

  getData: ->
    @loading = true
    @$('.js-loading-card-actions').show()

    @waitForId @model, =>
      limit = if @fShowAllActions then @maxActionLimit else @defaultActionLimit
      Promise.try =>
        if !Auth.isLoggedIn() || Auth.me().getShowDetails()
          ModelLoader.loadCardDetails @model.id, limit
        else
          ModelLoader.loadCardHideDetails @model.id, limit
      .finally =>
        @loading = false
        @$('.js-loading-card-actions').hide()
      .then =>
        @renderShowAllActionsButton()
        @scrollToHighlight()
      .done()

    return

  render: ->
    @fShowAllAttachments = false
    @fShowAllTrelloAttachments = false
    @fShowAllActions = false

    data = _.extend @model.toJSON(),
      canComment: @model.getBoard().canComment(Auth.me()) && !@isOnBoardTemplate()
      isLoggedIn: Auth.isLoggedIn()
      canToggleDetails: Auth.isLoggedIn()
      hasAttachments: @model.attachmentList.length > 0
      me: Auth.me().toJSON()
      loading: @loading
      editable: @model.editable()
      subscribeOnComment: Auth.me().isSubscribeOnCommentEnabled()
      isOnBoardTemplate: @isOnBoardTemplate()
      isSubscribed: @model.get('subscribed') || @model.get('badges')?.subscribed
      hideVotes: !!@model.getBoard().get('prefs')?.hideVotes
      viewingMemberVoted: @model.get('badges')?.viewingMemberVoted
      cardCoverChooserEnabled: @model.getBoard().getPref('cardCovers')
      cardCoverIsAttachment: @model.hasAttachmentCover()
      isTemplate: !!@model.get('isTemplate')

    @$el.html cardDetailTemplate(data)

    @actionListView.setElement @$('.js-list-actions')[0]

    @commentInput = @$('.js-new-comment-input')[0]

    @renderCover()
    .renderStickers()
    .renderName()
    .renderList()
    .renderActionList()
    .renderShowAllActionsButton()
    .renderMembers()
    .renderSuggestedActions()
    .renderArchived()
    .renderDelete()
    .renderChecklists()
    .renderCardTemplate()
    .renderSubscribe()
    .renderVotes()
    .renderDueDate()
    .renderAttachments()
    .renderLocation()
    .renderPluginSections()
    .renderAddAttachments()
    .renderAddChecklists()
    .renderLabels()
    .renderAging()
    .renderEditing()
    .renderCustomFieldBadges()
    .renderPluginBadges()
    .renderPluginButtons()
    .renderBanner()
    .renderCopyCard()

    @appendSubview @descView, @$('.js-fill-card-detail-desc')

    if data.canComment
      @recallDrafts()

    _.defer =>
      @$('.js-card-detail-title-input').autosize(append: false)
      @$('.js-new-comment-input').autosize(append: false)
      @renderCommentControls()

    Dates.update(@el)

    @

  getCard: ->
    @model

  getTextInput: ->
    return @$('.js-new-comment-input')

  getMentionTarget: ->
    return @$('.js-comment-mention-member:visible')[0]

  getEmojiTarget: ->
    return @$('.js-comment-add-emoji:visible')[0]

  closeDialog: ->
    Dialog.hide()

  showMoreMenu: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: @$('.js-more-menu')
      view: CardDetailMoreMenuView
      options: { @model, @modelCache }

    trackUe(
      "card sidebar", "opens", "share and more menu", "", "", 'by clicking share button',
      { cardid: @model.id, boardid: @model.getBoard().id }
    )
    return

  renderList: ->
    list = @model.getList()

    # It's possible that the list won't be loaded, if the card has been moved
    # to another board
    @$('.js-current-list')
      .html cardDetailListTemplate({
        listName: list?.get('name') ? "…",
        editable: @model.editable()
      })

    @

  expandDesc: ->
    # For `showCardDetail` in card view
    @descView.expandDesc()

  renderBanner: ->
    renderComponent(React.createElement(CardBackBanner, {
      idCard: @model.id
      editable: @model.editable()
    }), @$('.js-card-banner')[0])

    @

  removeBanner: ->
    ReactDOM.unmountComponentAtNode(@$('.js-card-banner')[0])

  # Comment functions
  keydownEvent: (e) ->
    # We're overriding keydownEvent from EditableView
    super
    Auth.me().editing({
      idBoard: @model.getBoard().id
      idCard: @model.id
      action: 'editing'
    })

  clearEdits: ->
    @_cancelEditing()
    super

  commitEdits: ->
    @_cancelEditing()
    # to hide the 'Edit' button for the description field
    @$('.card-detail-description .editing').removeClass('editing')
    super

  stopEditing: ->
    @_cancelEditing()
    super

  recallDrafts: ->
    commentDraftText = Storage.get @_commentDraftKey()
    if commentDraftText
      @$('.js-new-comment-input').val(commentDraftText)
    @renderCommentSubmitAbility()
    super

  saveCommentDraft: saveCommentDraft
  keydownCommentEvent: keydownCommentEvent
  _isCommentTooLong: _isCommentTooLong
  renderCommentSubmitAbility: renderCommentSubmitAbility
  renderCommentControls: renderCommentControls
  renderCommentAndSubscribeBox: renderCommentAndSubscribeBox
  _cancelEditing: _cancelEditing
  commentInputEvent: commentInputEvent
  clearComment: clearComment
  submitComment: submitComment
  subscribeOnComment: subscribeOnComment
  replyToComment: replyToComment
  truncateComment: truncateComment
  attachComment: attachComment
  inputComment: inputComment
  clickAwayFromComment: clickAwayFromComment
  collapseComment: collapseComment
  replyToAction: replyToAction
  replyToAllAction: replyToAllAction
  replyToAttachment: replyToAttachment
  _commentDraftKey: _commentDraftKey

  # Notifications functions
  markNotificationsReadOnActive: markNotificationsReadOnActive
  markRelatedNotificationsRead: markRelatedNotificationsRead

  # Attachment functions
  incrementNumAttachmentsProcessing: incrementNumAttachmentsProcessing
  decrementNumAttachmentsProcessing: decrementNumAttachmentsProcessing
  incrementNumTrelloAttachmentsProcessing: incrementNumTrelloAttachmentsProcessing
  decrementNumTrelloAttachmentsProcessing: decrementNumTrelloAttachmentsProcessing
  enableAttachmentSorting: enableAttachmentSorting
  getTrelloAttachments: getTrelloAttachments

  # Highlight functions
  scrollToHighlight: scrollToHighlight
  highlight: highlight
  interceptHighlightLink: interceptHighlightLink

  # Card name functions
  saveCardName: saveCardName
  nameKeyDownEvent: nameKeyDownEvent
  startNameEditing: startNameEditing
  saveNameEditing: saveNameEditing
  cancelNameEditing: cancelNameEditing
  stopNameEditing: stopNameEditing
  renderName: renderName
  editTitle: editTitle

  # Archiving/deleting functions
  archiveCard: archiveCard
  unarchiveCard: unarchiveCard
  deleteCardSidebar: deleteCardSidebar
  renderArchived: renderArchived
  renderDelete: renderDelete

  # Copy/move functions
  renderCopyCard: renderCopyCard
  openMoveMenu: openMoveMenu
  openMoveFromHeader: openMoveFromHeader
  moveCard: moveCard
  copyCard: copyCard

  # Label functions
  renderLabels: renderLabels
  openLabelsPopOver: openLabelsPopOver
  editLabelsMainSingleLabel: editLabelsMainSingleLabel
  editLabelsMain: editLabelsMain
  editLabelsSidebar: editLabelsSidebar
  _openEditLabelsSidebar: _openEditLabelsSidebar

  # Voting functions
  showVotes: showVotes
  renderVotes: renderVotes
  vote: vote
  unvote: unvote

  # Cover functions
  removeCover: removeCover
  showCover: showCover
  checkShowCover: checkShowCover
  clearCover: clearCover
  renderCover: renderCover
  cardCoverChooserSidebar: cardCoverChooserSidebar

  # Checklist functions
  renderAddChecklists: renderAddChecklists
  renderDueDate: renderDueDate
  sortChecklists: sortChecklists
  removeChecklist: removeChecklist
  renderChecklists: renderChecklists
  sortStop: sortStop

  # Member functions
  renderMembers: renderMembers
  renderEditing: renderEditing
  openEditMembersPopOver: openEditMembersPopOver
  editMembersMain: editMembersMain
  changeMembersSidebar: changeMembersSidebar
  join: join

  # Checklist functions
  onChecklistClick: onChecklistClick
  onChecklistShortcut: onChecklistShortcut
  addChecklistSidebar: addChecklistSidebar
  showDueDateBadgeMenu: showDueDateBadgeMenu
  toggleDueDateComplete: toggleDueDateComplete
  dueDateSidebar: dueDateSidebar
  focusChecklistAdd: focusChecklistAdd

  # Attachment functions
  renderAttachments: renderAttachments
  sortStopAttachments: sortStopAttachments
  renderAddAttachments: renderAddAttachments
  showFewerAttachments: showFewerAttachments
  showMoreAttachments: showMoreAttachments
  showFewerTrelloAttachments: showFewerTrelloAttachments
  showMoreTrelloAttachments: showMoreTrelloAttachments
  openCoverInViewer: openCoverInViewer
  openAttachPicker: openAttachPicker
  openAttachTrelloPicker: openAttachTrelloPicker
  dragenter: dragenter
  dragleave: dragleave
  dropFiles: dropFiles
  dropUrl: dropUrl

  # Subscribe/unsubscribe functions
  subscribeToCard: subscribeToCard
  unsubscribeFromCard: unsubscribeFromCard
  renderSubscribe: renderSubscribe

  # Action functions
  showAllActions: showAllActions
  renderShowAllActionsButton: renderShowAllActionsButton
  renderActionList: renderActionList
  renderSuggestedActions: renderSuggestedActions
  showDetails: showDetails
  hideDetails: hideDetails

  # Plugin functions
  renderAging: renderAging
  dismissPluginSuggestionSection: dismissPluginSuggestionSection
  enableSuggestedPluginPrompt: enableSuggestedPluginPrompt
  renderPluginSections: renderPluginSections
  editFieldsSidebar: editFieldsSidebar
  editLocationSidebar: editLocationSidebar
  renderLocation: renderLocation
  renderPluginButtons: renderPluginButtons
  renderCustomFieldBadges: renderCustomFieldBadges
  renderPluginBadges: renderPluginBadges
  renderStickers: renderStickers
  cardAgingSidebar: cardAgingSidebar

  # Template functions
  convertToTemplate: convertToTemplate
  convertToCard: convertToCard
  renderCardTemplate: renderCardTemplate
  isOnBoardTemplate: isOnBoardTemplate
